import React from 'react';
import { useEffect, useState } from 'react';
import NumberInput from '~ComponentsImproved/Numpad';
import { useStorage } from '~Components/Storage';
import { useI18n } from '~Hooks';
import { v4 as uuid } from 'uuid';
import { MethodProps } from '../types';

const CustomWithTip: React.FunctionComponent<MethodProps & {
  fail?: boolean;
}> = ({ payment, onComplete, onFail, fail = false }) => {
  const [storage] = useStorage();
  const { i18n } = useI18n();
  const [showTipModal, setShowTipModal] = useState(!payment.disableTip && storage.enableTipping);

  useEffect(() => {
    if (showTipModal) {
      return;
    }

    const handlePayment = () => {
      if (fail) {
        onFail(i18n('Swish.PaymentFailed'));
      } else {
        onComplete(undefined, { transactionId: uuid() });
      }
    };

    setTimeout(handlePayment, 2500);
  }, []);

  if (showTipModal) {
    return (
      <NumberInput
        key="tip"
        initialValue={'0'}
        decimal
        title={i18n('TM.Tip')}
        onSubmit={(tipAmount) => {
          setShowTipModal(false);

          // Ensure input is valid
          const num = parseFloat(tipAmount);
          if (isNaN(num)) {
            onFail(i18n('Payment.Canceled'));
            return;
          }

          // Complete payment with added tip after a slight delay
          setTimeout(() => onComplete(undefined, { tip: num * 100, transactionId: uuid() }), 2000);
        }}
        onClose={() => {
          onFail(i18n('Payment.Canceled'));
        }}
      />
    );
  } else {
    // Complete payment without tip
    setTimeout(() => onComplete(undefined, { transactionId: uuid() }), 2000);
  }

  return null;
};

export default CustomWithTip;
